<template>
  <div>
    <article class="etablissement-entry">
      <header>
        <a :href="url(etablissement)">
          <h3 class="etablissement-title">{{ etablissement.title }}</h3>
        </a>
      </header>
      <div>
        <ul>
          <li><strong>Adresse</strong> {{ address(etablissement) }}</li>
          <li><strong>Disp</strong> {{ etablissement.disp.label }}</li>
          <li><strong>Date de mise en service</strong> {{ etablissement.date_de_mise_en_service }}</li>
          <li><strong>Nature</strong> {{ natures(etablissement) }}</li>
        </ul>
      </div>
    </article>
  </div>
</template>

<script>
  export default {
    props: {
      etablissement: {
        type: Object,
        required: true
      }
    },

    methods: {

      url (etablissement) {
        return '/sinformer/etablissements/' + etablissement.slug
      },

      natures (etablissement) {
        let natures = []
        _.forEach(etablissement.nature_de_letablissement, function (item) {
          natures.push(item.label)
        })

        return _.join(natures, ', ')

        return etablissement.nature_de_letablissement[0].label
      },

      address (etablissment) {
        return etablissment.localisation.address.replace(', France', '')
      }

    }

  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/etablissements/EtablissementEntry.vue